import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CustomButton from "../../../components/CustomButton";

const PromptMissingBox18 = ({ show, onCancel, onContinue }: any) => {

  return (
    <Modal
      disableAutoFocus
      open={show}
      onClose={() => onCancel()}
      aria-labelledby="missing-box-18-modal"
      className={'modal-container'}
    >
      <div className={'modal-paper'}>
        <Box component="h3" m={1} className={'modal-title'}>
          Review your W2 data
        </Box>
        <p className={'modal-sub-title'}>
            You left box 18 (Local wages, tips, etc.) blank. 
            Please review your W-2 form to ensure this is correct.</p>
        <Box className={'modal-button-container'} sx={{marginTop: '1em'}}>
          <CustomButton
            variant="outlined"
            disableElevation={false}
            label={"Cancel"}
            onClick={() => onCancel()}
          />
          <CustomButton
            variant="contained"
            disableElevation={false}
            label={"Continue"}
            onClick={() => onContinue()}
          />
        </Box>
      </div>
    </Modal>
  );
};

export default PromptMissingBox18;
